import { useEffect, useState } from 'react';

import { Modal, Form, Button } from 'react-bootstrap';

export const RunNotesModal = ({ onHide, onSubmit, placeholder, prompt, show, submitLabel, title }) => {

    const [notes, setNotes] = useState('');

    useEffect(() => {

        if (show) setNotes('');

    }, [show]);

    const submit = () => onSubmit(notes.trim() || null);

    return (

        <Modal centered onHide={onHide} show={show}>

            <Modal.Header closeButton>
                <Modal.Title>
                    {title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {prompt && (
                <p className="text-muted small mb-2">
                    {prompt}
                </p>
                )}

                <Form.Control
                    autoFocus
                    as="textarea"
                    onChange={e => setNotes(e.target.value)}
                    placeholder={placeholder}
                    rows={4}
                    value={notes}
                />

            </Modal.Body>

            <Modal.Footer>
                <Button onClick={onHide} variant="outline-secondary">
                    Cancel
                </Button>
                <Button onClick={submit} variant="primary">
                    {submitLabel || 'Submit'}
                </Button>
            </Modal.Footer>

        </Modal>

    );

};
